// extracted by mini-css-extract-plugin
module.exports = {"label":"ChangeFormStyle_label__3ZPDn","box":"ChangeFormStyle_box__HNZTs","container":"ChangeFormStyle_container__1AtsJ"};